export default {
   namespaced: true,
   state: {
      // 网页授权登录获取到的code
      code: '',
   },
   actions: {
      /**
       * @description 设置数据
       * @param {Object} context
       * @param {*} info info
       */
      async set({ state, dispatch }, code) {
         console.log(code, 'codecodecodecode')
         // store 赋值
         state.code = code
         // 持久化
         await dispatch(
            'tccc/db/set',
            {
               dbName: 'sys',
               path: 'login.code',
               value: code,
               user: true,
            },
            { root: true }
         )
      },
      /**
       * @description 从数据库取数据
       * @param {Object} context
       */
      async load({ state, dispatch }) {
         let code = await dispatch(
            'tccc/db/get',
            {
               dbName: 'sys',
               path: 'login.code',
               defaultValue: {},
               user: true,
            },
            { root: true }
         )
         // store 赋值
         state.code = code
      },
   },
}
